import { ANY_ATTACHED, WHOLE_TEXT, type AttachedFilter, type SearchIn } from "../../../api/content/searchApi";
import { narrowingCount } from "../attached/attachedFilter";

/**
 * What the search keeps, and with it the Documents sidebar's lists (F88): the data attached to
 * the documents, and where the words are matched (F141). A search limited to a kind of segment
 * matches its words there, and its labels only where they lie in it.
 */
export interface SearchFilters {
  readonly attached: AttachedFilter;
  readonly searchIn: SearchIn;
}

export const NO_SEARCH_FILTERS: SearchFilters = { attached: ANY_ATTACHED, searchIn: WHOLE_TEXT };

/** How many choices narrow the search or move it; 0 searches every document's whole text. */
export function filterCount(filters: SearchFilters): number {
  const moved = filters.searchIn.kind === "statements" || filters.searchIn.segmentType !== null;
  return narrowingCount(filters.attached) + (moved ? 1 : 0);
}

/** The kind of segment the labels named are taken from: the one the text is searched in, or none. */
export function labelSegmentType(filters: SearchFilters): string | null {
  return filters.searchIn.kind === "text" ? filters.searchIn.segmentType : null;
}

/** The kinds of segment the corpora declare, each once, shallowest first as each corpus lists them. */
export function segmentTypesOf(corpora: readonly { readonly segmentTypes: readonly string[] }[]): readonly string[] {
  return [...new Set(corpora.flatMap((corpus) => corpus.segmentTypes))];
}
